/**
 *
 * constants for api request/response mapping
*/

export const userModel = {
  ID: 'id',
  USERNAME: 'userName',
  FIRST_NAME: 'firstName',
  SUR_NAME: 'surName',
  EMAIL: 'email',
  STATUS: 'status',
  INSERT_DATE: 'insertDate',
  PHONE: 'phone',
  COMMENT: 'comment',
  STATUS_VALUE: {
    ACTIVE: '1',
    PASSIVE: '0',
    ALL: null
  },
  SHORTAGE_HISTORY: {
    COMPANY_NAME: 'companyName',
    GTIN: 'gtin',
    SHORTAGE_TYPE: 'shortageType',
    SHORTAGE_TYPE_VALUE: 'shortageTypeValue',
    SHORTAGE_TYPE_OTHER: 'shortageTypeOther',
    SHORTAGE_REASON: 'shortageReason',
    SHORTAGE_REASON_VALUE: 'shortageReasonValue',
    SHORTAGE_REASON_OTHER: 'shortageReasonOther',
    AVAILABLE_QUANTITY: 'availableQuantity',
    DISTRIBUTED_QUANTITY: 'distributedQuantity',
    AVAILABILITY_STATUS: 'availabilityStatus',
    AVAILABILITY_STATUS_VALUE: 'availabilityStatusValue',
    REQUESTED_STATUS: 'requestedStatus',
    REQUESTED_STATUS_VALUE: 'requestedStatusValue',
    APPROVAL_STATUS: 'approvalStatus',
    APPROVAL_STATUS_VALUE: 'approvalStatusValue',
    USER_NAME: 'userName',
    ASSIGN_TO: 'assignTo',
    UPDATE_TIME: 'updateTime',
    COMMENT: 'comment'
  },
  HISTORY: {
    USERNAME: 'username',
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    SUR_NAME: 'surname',
    PHONE: 'phone',
    STATUS: 'status',
    UPDATING_USER: 'updatingUser',
    COMMENT: 'comment',
    UPDATE_TIME: 'updateTime'
  },
  RESET_PASSWORD: {
    USERNAME: 'UserName'
  },
  USER_ACTIVATION: {
    USERNAME: 'userName'
  }
};

export const paginationModel = {
  CURRENT_PAGE: 'current_page',
  PAGE: 'page',
  PAGES: 'pages',
  TOTAL: 'total',
  DATA: 'data',
  PAGE_SIZE: 'page_size',
  TOTAL_RECORDS: 'totalRecords',
  PER_PAGE: 'perPage',
  ROWS: 'rows'
};

export const loginModel = {
  ACCESS_TOKEN: 'accessToken',
  PASSWORD: 'password',
  USERNAME: 'username',
  FULL_NAME: 'fullname',
  REFRESH_TOKEN: 'refreshToken',
  NEW_REFRESH_TOKEN: 'newRefreshToken',
  USER_STATUS: 'status',
  PORTAL: 'portal',
  SUCCESS: 'success',
  RESPONSE_CODE: 'responsecode',
  RESPONSE_MESSAGE_AR: 'responseMessageAr',
  RESPONSE_MESSAGE_EN: 'responseMessageEn',
  PRIVILAGE_IDs: 'privilageIds',
  IS_AUTHORIZED_REPORTING: 'is_authorized_reporting',
  IS_REQUIRED_NEW_PASSWORD: 'is_Required_New_Password',
  STAKEHOLDER_TYPE: 'stakeholderType'
};

export const drugsModel = {
  NAME: 'name', // generic name
  GENERIC_NAME: 'genericName', // generic name
  DRUG_NAME: 'drugName',
  REG_NO: 'registrationNo',
  IS_IMP: 'isImportable',
  IS_EXP: 'isExportable',
  IS_ONLY_HOSPITAL: 'isOnlyHospital',
  VALUE: 'drugStatusCache',
  ESS_LEVEL: 'essentialityLevel',
  REMARK: 'note',
  GTIN: 'gtin',
  COMPANY_ID: 'companyId',
  STATUS: 'status',
  SH_ID: 'stakeholderId',
  ID: 'id',
  STATUS_VALUE: {
    ACTIVE: '1',
    PASSIVE: '0',
    ALL: null
  },
  REGISTERED_VALUE: {
    REGISTERED: '1',
    UNREGISTERED: '0',
    ALL: null
  },
  REVIEWED_VALUE: {
    REVIEWED: '1',
    UNREVIEWED: '0',
    ALL: null
  },
  GLN_OR_QUERY: 'GlnORName',
  NAME_OR_GTIN: 'nameOrGtin',
  LIMIT_QUANTITY: 'limitQuantity',
  DRUG_REQUEST_STATUS: {
    WAITING_FOR_APPROVAL: '1',
    APPROVED: '2',
    REJECTED: '3'
  }
};

export const establishmentModel = {
  ID: 'id',
  NAME: 'name',
  PHONE: 'phone',
  EMAIL: 'email',
  ADDRESS: 'address',
  CITY_NAME: 'cityName',
  CONTACT_PERSON_NAME: 'contactPersonName',
  CONTACT_PERSON_PHONE: 'contactPersonPhone',
  COMPANY_TYPE: 'companyType',
  STATUS: 'status',
  STATUS_VALUE: {
    NOTAPPROVED: '1',
    PASSIVE: '2',
    ACTIVE: '4',
    ALL: null
  },
  TYPE_VALUES: {
    GOVERMENTAL: '2',
    PRIVATE: '1',
    ALL: null
  }
};
export const stakeholderModel = {
  STATUS_VALUE: {
    ACTIVE: '1',
    PASSIVE: '0',
    ALL: null,
    ACTIVE_LABEL: 'Active',
    PASSIVE_LABEL: 'Active',
    WAITING_FOR_APPROVAL_1: '0',
    WAITING_FOR_APPROVAL_2: '1',
    REJECTED: '2',
    WAITING_REVISION: '3',
    APPROVED: '4'
  },
  SHORTAGE_STATUS: {
    ALL: null,
    WAITING_FOR_APPROVAL: '1',
    REJECTED: '2',
    APPROVED: '4'
  },
  NEW_OR_EDIT_SH: {
    ALL: '0',
    NEW: '1',
    EDIT: '2'
  },
  TYPE_VALUES: {
    MANUFACTURER: '1',
    WAREHOUSE: '2',
    PHARMACY: '4',
    CONSUMPTION_CENTER: '5',
    REIMBURSEMENT_AGENCY: '6',
    ALL2: null,
    ALL: null
  },
  PRODUCT_CONTROLLED_STATUS_VALUES: {
    CONTROLLED: '1',
    UNCONTROLLED: '0'
  },
  ID: 'id',
  GLN: 'gln',
  EMAIL: 'email',
  STAKEHOLDER_NAME: 'stakeholderName',
  STAKEHOLDER_TYPE: 'stakeholderType',
  SUB_USERS: 'cbSubUser',
  USERNAME: 'userName',
  NAME: 'name',
  FIRST_NAME: 'firstName',
  SUR_NAME: 'surName',
  SH_NAME: 'shName',
  STATUS: 'status',
  ADDRESS: 'address',
  LICENSE_NUMBER: 'licenseNumber',
  PHONE: 'phone',
  RESPONSIBLE_F_NAME: 'responsiblePersonFirstName',
  RESPONSIBLE_S_NAME: 'responsiblePersonSurName',
  DISTRICT: 'district',
  CITY: 'city',
  ESTABLISHMENT: 'establishment',
  INSERT_DATE: 'insertDate',
  HISTORY: {
    USERNAME: 'username',
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    SUR_NAME: 'surname',
    PHONE: 'phone',
    STATUS: 'status',
    UPDATING_USER: 'updatingUser',
    COMMENT: 'comment',
    UPDATE_TIME: 'updateTime'
  },
  HAS_USER: 'hasUser',
  ESTABLISHMENT_EMAIL: 'establishmentEmail',
  REQUEST_TIME: 'requestTime',
  REQUEST_ID: 'requestID',
  STAKEHOLDER_NAME_AR: 'stakeholderNameAr',
  REGION: 'region',
  ADDRESS_AR: 'addressAr',
  RESPONSIBLE_P_PHONE: 'responsiblePersonPhone',
  LATITUDE: 'locationLatitude',
  LONGITUDE: 'locationLongitude',
  UPDATING_USER: 'updatingUser',
  UPDATE_TIME: 'updateTime',
  DESCRIPTION: 'description',
  ESTABLISHMENT_NOTE: 'establishmentNote',
  DOMAINS: {
    HUMAN: 1,
    VET: 2
  }
};

export const unitsModel = {
  NOTIFICATION_ID: 'notificationId',
  NOTIFICATION_DATE: 'notificationDate',
  GLN: 'gln',
  SOURCE_STAKEHOLDER: 'sourceGln',
  DESTINATION_GLN: 'destinationGln',
  SOURCE_GLN: 'sourceGln',
  SOURCE_NAME: 'sournceName',
  END_DATE: 'endDate',
  START_DATE: 'startDate',
  INSERT_TIME: 'insertTime',
  STAKEHOLDER_TYPE: 'stakeholderType',
  ESTABLISHMENT: 'establishment',
  BN: 'bn',
  SN: 'sn',
  EXPIRY_DATE: 'expiryDate',
  MANUFACTURE_DATE: 'manufactureDate',
  NOTIFICATION_COUNT: 'notificationCount',
  SUCCESSFUL: 'successfullProductionCount',
  UNSUCCESSFUL: 'unSuccessfullProductionCount',
  TRACK_ID: 'id',
  GTIN: 'drugGtin',
  UNIT_NAME: 'productName',
  NAME_SURNAME: 'nameSurname',
  PHONE: 'phone',
  PURCHASED_FROM: 'purchasedFrom',
  DATE: 'dateTime',
  READ: 'isRead',
  ANSWERED: 'isAnswered',
  VALID: 'isDeleted',
  INVESTIGATION_RESULT: 'itemName',
  TYPE: 'resultCode',
  USERNAME: 'username',
  USERNAME_INFO: 'usernameInfo',
  ITEM_NAME: 'itemName',
  UPDATE_TIME: 'insertTime', // double check
  ID: 'id',

  UNDEFINED_SERVICE_TYPE: {
    LABEL: 'resultCode',
    ALL: null,
    GTIN: '0',
    SN: '1'
  },
  UNDEFINED_SERVICE_OPERATION: {
    LABEL: 'operation',
    ALL: null,
    ACCEPT: '101',
    BLOCK: '116',
    BLOCK_CANCEL: '117',
    BLOCK_CANCEL_AND_RECALL: '120',
    CHECK_STATUS: '108',
    CONSUME: '111',
    CONSUME_CANCEL: '112',
    DEACTIVATE: '106',
    DEACTIVATION_CANCEL: '124',
    DISPATCH: '103',
    DISPACH_ACCEPT: '125',
    DISPATCH_CANCEL: '104',
    EXPORT: '105',
    EXPORT_CANCEL: '113',
    IMPORT: '119',
    IMPORT_CANCEL: '123',
    PHARMACY_SALE: '109',
    PHARMACY_SALE_CANCEL: '110',
    RECALL: '118',
    RECALL_CANCEL: '121',
    RETURN: '102',
    SUPPLY: '100',
    SUPPLY_CANCEL: '122',
    TRANSFER: '114',
    TRANSFER_CANCEL: '115'
  },
  WEBSERVICE_OPERATION: {
    LABEL: 'Operation Type',
    notifyPharmacySale: 'notifyPharmacySale',
    sideEffectNotification: 'sideEffectNotification',
    undefinedProductNotification: 'undefinedProductNotification',
    upsertUser: 'upsertUser',
    notifyTransfer: 'notifyTransfer',
    notifyDispatch: 'notifyDispatch',
    notifyAccept: 'notifyAccept',
    notifyDeactivation: 'notifyDeactivation',
    getDrugInfo: 'getDrugInfo',
    notifyUndefinedProduct: 'notifyUndefinedProduct',
    notifyBlock: 'notifyBlock',
    notifySupply: 'notifySupply',
    notifyImport: 'notifyImport'
  },
  UNDEFINED_MOBILE_READ: {
    LABEL: 'isRead',
    ALL: null,
    YES: 1,
    NO: 0
  },
  UNDEFINED_MOBILE_ANSWERED: {
    LABEL: 'isAnswered',
    ALL: null,
    YES: 1,
    NO: 0
  },
  ENTERED: {
    ALL: null,
    YES: 1,
    NO: 0
  },
  FEEDBACK_SENT: {
    ALL: null,
    YES: 1,
    NO: 0
  }
};

export const regionModel = {
  ALBAHAH: '1',
  ALJAWF: '2',
  ALMADINAH: '3',
  ALQASSIM: '4',
  ASIR: '5',
  EASTERN_REGION: '6',
  HAIL: '7',
  JIZAN: '8',
  MAKKAH: '9',
  NAJRAN: '10',
  NORTHERN_BORDERS: '11',
  RIYADH: '12',
  TABUK: '13',
  OUTSIDE_KSA: '50'
};

export const citiesModel = {
  ALL: '0',
  ALAQIQ: '1', // albahah
  ALBAHA: '2',
  ALMANDAQ: '3',
  ALMUKHWA: '4',
  ALQURA: '5',
  BALJURASHI: '6',
  QULWAH: '7',
  ALQARIYAT: '8', // aljawf
  DAWMAT_ALJANDAL: '9',
  SAKAKA: '10',
  ALHANAKIAYH: '11', // almadinah
  ALMADINAH: '12',
  ALMAHD: '13',
  ALOLA: '14',
  BADR: '15',
  KHAILBAR: '16',
  YANBU_ALBAHR: '17',
  ALASYAH: '18', // alqassim
  ALBADAIA: '19',
  ALBUKIERIYAH: '20',
  ALMAZNAB: '21',
  ALNABHANIYAH: '22',
  ALRASS: '23',
  ALSHAMASIYAH: '24',
  BURIEDAH: '25',
  ONIEZAH: '26',
  OYOON_ALJEWAA: '27',
  RIYADH_ALKHUBRAA: '28',
  ABHA: '29', // asir
  AHAD_RUFIEDAH: '30',
  ALMAJARDAH: '31',
  ALNAMS: '32',
  BALQARN: '33',
  BIESHA: '34',
  DHAHRAN_ALJANOUB: '35',
  KHAMIS_MISHIET: '36',
  MAHAIEL: '37',
  RIJAL_ALMAA: '38',
  SURAT_OBIEDAH: '39',
  TATHIETH: '40',
  ABGIG: '41', // eastern region
  ALAHSA: '42',
  ALDAMMAM: '43',
  ALJUBAIL: '44',
  ALKHAFJI: '45',
  ALKHOBAR: '46',
  ALNUAEIYAH: '47',
  ALQATEIF: '48',
  HAFR_ALBATIN: '49',
  QARIYAT_ALOLIYAH: '50',
  RAS_TANNOURA: '51',
  ALSHANAN: '52', // hail
  BAQAA: '53',
  GHAZALAH: '54',
  HAIL: '55',
  ABUARIEESH: '56', // jizan
  AHD_ALMASARHA: '57',
  ALARDHAH: '58',
  ALDAIR: '59',
  ALDARB: '60',
  ALHRATH: '61',
  ALIDABI: '62',
  BIESH: '63',
  DHAMD: '64',
  FURSAN: '65',
  JIZAN: '66',
  RAITH: '67',
  SABIYAA: '68',
  SAMTAH: '69',
  ALJAMOUM: '70', // makkah
  ALKAMEL: '71',
  ALKHURMAH: '72',
  ALLIETH: '73',
  ALQUNFUDAH: '74',
  ALTAIEF: '75',
  JEDDAH: '76',
  KHULIES: '77',
  MAKKAH: '78',
  RABIGH: '79',
  RANIYAH: '80',
  TURBAH: '81',
  ALKHARKIR: '82', // najran
  BADR_ALJANOUB: '83',
  HABOUNA: '84',
  KHABASH: '85',
  NAJRAN: '86',
  SHARORAH: '87',
  THAR: '88',
  YIADMAH: '89',
  ARAR: '90', // northern borders
  RAFHA: '91',
  TRAIF: '92',
  AFIF: '93', // riyadh
  ALAFLAJ: '94',
  ALDAWDMI: '95',
  ALDIRIYAH: '96',
  ALGHAT: '97',
  ALHARIEQ: '98',
  ALKHARJ: '99',
  ALMAJMAAH: '100',
  ALMUZAHMIYAH: '101',
  ALQWIEIYAH: '102',
  ALRIYADH: '103',
  ALSALIL: '104',
  ALZULFA: '105',
  DHIRAM: '106',
  HOTAT_BANI_TAMIM: '107',
  HURIMILA: '108',
  RAMAMH: '109',
  SHAQRAA: '110',
  THADIQ: '111',
  WADI_ALDWASIR: '112',
  ALWAJH: '113', // tabuk
  ALMLAJ: '114',
  DHIBA: '115',
  HAQL: '116',
  TABUK: '117',
  TAYMA: '118',
  OUTSIDE_KSA: '119'
};

export const responseModel = {
  ROWS: 'rows',
  RESPONSE_CODE: 'responsecode',
  RESPONSE_MESSAGE_AR: 'responseMessageAr',
  RESPONSE_MESSAGE_EN: 'responseMessageEn'
};

export const mailModel = {
  ID: 'id',
  TO: 'mailTo',
  SUBJECT: 'subject',
  INSERT_TIME: 'insertTime',
  SEND_TIME: 'sendTime',
  STATUS: 'status',
  RETRY_COUNT: 'retryCount',
  STATUS_VALUE: {
    PENDING: '1',
    ERROR: '2',
    SENT: '3'
  },
  SENDER_MAIL_ADDRESS: 'senderMailAddress',
  DISPLAY_NAME: 'dispalyName',
  HOST: 'host',
  PORT: 'port',
  USERNAME: 'username',
  PASSWORD: 'password',
  SSL: 'ssl',
  SSL_VALUE: {
    NO: '0',
    YES: '1'
  },
  ERROR_DATE: 'errorDate',
  ERROR_CONTENT: 'errorContent'
};

export const stakeholderGradesModel = {
  ID: 'id',
  GLN: 'gln',
  STAKEHOLDER_NAME: 'stakeholderName',
  ESTABLISHMENT: 'company',
  CITY: 'city',
  DISTRICT: 'districtId',
  STAKEHOLDER_TYPE: 'stakeholderType',
  STATUS: 'status',
  GRADE: 'grade',
  EVALUATED_SH_ID: 'evaluatedShId',
  STATUS_VALUE: {
    ACTIVE: '1',
    PASSIVE: '0',
    ALL: null
  }
};

export const drugByGtin = {
  DRUG_NAME: 'drugName',
  REGISTRATION_NUMBER: 'registrationNo',
  GTIN: 'gtin',
  STATUS: 'status',
  STAKEHOLDER: 'stakeholder',
  GENERIC_NAME: 'genericName',
  REGISTERED: 'registered',
  REVIEWED: 'reviewed',
  TRADE_NAME: 'name',
  TRADE_NAME_AR: 'nameAr',
  GENERIC_NAME_AR: 'genericNameAr',
  IS_ONLY_HOSPITAL: 'isonlyHospital',
  LEGAL_STATUS: 'legalStatus',
  PRODUCT_CONTROL: 'productControl',
  AUTHORIZATION_STATUS: 'authorizationStatus',
  MARKETING_STATUS: 'marketingStatus',
  PRICE: 'price',
  ATC_CODE_1: 'atcCode1',
  ATC_CODE_2: 'atcCode2',
  MANUFACTURER_NAME: 'manufacturerName',
  MARKETING_COMPANY: 'marketingCompany',
  MARKETING_COMPANY_COUNTRY: 'marketingCompanyCountry',
  PACKAGE_SIZE: 'packageSize',
  PACKAGE_TYPE: 'packageType',
  ROUTE_OF_ADMINISTRATION: 'routeOfAdministration',
  SHELF_LIFE: 'shelfLife',
  STORAGE_CONDITION: 'storageCondition',
  STRENGHT_VALUE: 'strengthValue',
  STRENGHT_VALUE_UNIT: 'strengthValueUnit',
  VOLUME: 'volume',
  UNIT_OF_VOLUME: 'unitOfVolume',
  MINIMUM_STOCK_LEVEL: 'supplierStockthreshold',
  ESSENTIALITY_LEVEL: 'supplierStockthreshold',
  DOSAGE_FORM: 'dosageForm',
  BLOCK_LEVEL: 'blockLevel',
  BLOCK_REASON: 'blockReason',
  DOMAIN_ID: 'domainId',
  NOTE: 'note'
};

export const ticketModel = {
  ID: 'id',
  TICKET_DATE: 'insertTime',
  STATUS: 'status',
  TITLE: 'title',
  STAKEHOLDER: 'spUserId',
  TYPE: 'type',
  USER_INFO: 'spUserinfo',
  DESCRIPTION: 'description',
  MESSAGES: 'ticketMessages',
  USER: 'insertUserInfo',
  CONTENT: 'content',
  INSERT_TIME: 'insertTime',
  ATTACHMENTS: 'attachments',
  FILE_NAME: 'fileName',
  STATUS_VALUE: {
    ALL: '0',
    OPEN: '1',
    IN_PROGRESS: '2',
    RESOLVED: '3',
    CLOSED: '4'
  },
  TYPE_VALUES: {
    UNIT_PROBLEMS: 1,
    INTEGRATIONS_PROBLEMS: 2,
    TECHNICAL_PROBLEMS: 3,
    QUERIES: 4,
    OTHER: 5
  }
};

export const RECALL_BLOCK_STATUS = {
  IN_PROGRESS: 0,
  COMPLETED: 1,
  ERROR_OCCURRED: 2,
  WAITING_FOR_APPROVAL: 3,
  DENIED: 5
};
